import io from 'socket.io-client';
const url = process.env.REACT_APP_API_URL;
const socket = io(url, {
    transports: ['websocket'],
}); // Ensure this matches your server URL

socket.on('connect', () => {
    console.log('Connected to WebSocket server');
});

socket.on('disconnect', () => {
    console.log('Disconnected from WebSocket server');
});

export default socket;
